import { CircularProgress } from "@mui/material";
import { useState, useRef, useEffect, useCallback, useMemo } from "react";
import { useSelector } from "react-redux";
import { useReactToPrint } from "react-to-print";
import logo_pdf from "../../Assets/svg/logo_pdf.svg";

export default function DownloadPdfDsdaV2() {
  const contentRef = useRef(null);
  const layer = useSelector((state) => state.layer);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({
    title: {
      layer: "",
      startDate: "",
      endDate: "",
    },
    head: [],
    body: [],
  });

  const allowedRekapitulasiPengerukanIds = useMemo(() => {
    return [
    {
      id: "6936d9500f8509d57e4bbcba",
      sub_title: "A. Rekapitulasi Pengerukan di DKI Jakarta",
      table_title: "Waduk/Situ/Embung,Sungai/Kali (Saluran Primer & Saluran Sekunder), Saluran Tersier (Saluran PHB)"
    },
    {
      id: "6936d9480f8509d57e4bbaba",
      sub_title: "B. Rekapitulasi Pemeliharaan Rutin di DKI Jakarta",
      table_title: "Saluran tersier (Saluran PHB) Melalui Laporan CRM, Pengurasan, Musrenbang dan Lain-Lain"
    },
    {
      id: "6936d4c10f8509d57e4b902d",
      sub_title: "C. Rekapitulasi Total Pengerukan dan Pemeliharaan Rutin",
      table_title: "Waduk/Situ/Embung,Sungai/Kali (Saluran Primer & Saluran Sekunder), Saluran Tersier (Saluran PHB)"
    },
  ]
  },[]) 

  const handlePrint = useReactToPrint({
    content: () => contentRef.current,
    documentTitle: "",
    pageStyle: `
        @page { size: ${allowedRekapitulasiPengerukanIds.map(item => item?.id).includes(layer?.layer_id) ? "A4" : "A3"} landscape; margin: 4mm 4mm 10mm 4mm}
        @media print {
            body { -webkit-print-color-adjust: exact; print-color-adjust: exact; margin: 0 !important; padding: 0 !important}
            html, body { margin: 0 !important; padding: 0 !important}
        }
        * {
          font-family: ${allowedRekapitulasiPengerukanIds.map(item => item?.id).includes(layer?.layer_id) ? "'Times New Roman', Times, serif !important" : "inherit !important"}
          }
        `,
    onBeforePrint: () => {
      setLoading(true);
    },
    onBeforeGetContent: () => {
      setLoading(true);
    },
    onAfterPrint: () => {
      setLoading(false);
    },
    onPrintError: () => {
      setLoading(false);
    },
  });

  const onClick = useCallback(() => {
    handlePrint();
  }, [handlePrint]);

  useEffect(() => {
    const { layer_id, geo_layer_list, sorted_by } = layer;
    const geo_layer = geo_layer_list.find(
      (e) => e?.geo_layer?._id === layer_id
    );

    if (!geo_layer?.geo_layer) return;
    let fields_layer = geo_layer.geo_layer.fields || [];
    fields_layer = fields_layer.filter(
      (d) =>
        ![
          "icon_image",
          "text_field",
          "fill_color",
          "circle_radius",
          "circle_stroke_width",
          "circle_stroke_color",
          "is_using_icon",
          "is_using_label",
        ].includes(d?.key)
    );

    let features_filtered =
      geo_layer?.geo_layer?.geojson_filtered?.features || [];
    let field, sort;
    if (sorted_by?.length > 0) {
      field = sorted_by?.[0]?.field;
      sort = sorted_by?.[0]?.sort;

      const isFromSmall = sort === "desc" ? false : true;
      const key = field;
      features_filtered = features_filtered?.sort((a, b) => {
        if (a?.properties?.[key] < b?.properties?.[key]) {
          return isFromSmall ? -1 : 1;
        }
        if (a?.properties?.[key] > b?.properties?.[key]) {
          return isFromSmall ? 1 : -1;
        }
        return 0;
      });
    }

    const fields = fields_layer;
    const key = fields?.map((d) => d?.key);

    const latLongKeys = fields
      ?.filter((field) => ["latitude", "longitude"]?.includes(field?.name))
      ?.map((field) => field?.key);

    let newData = features_filtered?.map((d, index) => {
      let obj = {};
      key.forEach((element) => {
        let value = "";
        if (d?.properties?.[element] !== undefined) {
          if (latLongKeys.includes(element)) {
            // menentukan digit desimal pada latitude dan longitude
            const newValue = d?.properties[element];
            value = String(newValue.toFixed(5));
          } else {
            value = String(d?.properties?.[element]);
          }
        } else if (d?.child_array?.[0]?.properties?.[element] !== undefined) {
          value = String(d?.child_array[0]?.properties?.[element]);
        }
        obj[element] = value;
      });
      return { ...obj, no: index + 1 };
    });

    const title = geo_layer?.geo_layer?.name;
    setData((prev) => ({ ...prev, title: { ...prev.title, layer: title } }));

    const schema = [
      ...fields?.map((d) => ({
        column: d?.name,
        type: d?.type,
        value: (data) => data?.[d.key],
      })),
    ];

    const listFilteredFields = [
      "Lokasi",
      "Permasalahan yang Ingin Diselesaikan",
      "Outcome", //Sasaran
      "Output", //Sasaran
      // "Daerah Rawan Banjir yang Ditangani",
      // "Target Volume Awal (m3)",
      // "Target Volume Akhir (m3)",
      "Volume Target (m³)",
      "Waktu Mulai", //Waktu Pelaksanaan (yyyy-mm-dd)
      "Waktu Selesai", //Waktu Pelaksanaan (yyyy-mm-dd)
      "Jumlah Alat Berat", //Rencana Kebutuhan Sumber Daya (Jml)
      "Jumlah Dump Truck", //Rencana Kebutuhan Sumber Daya (Jml)
      "Jumlah Satgas", //Rencana Kebutuhan Sumber Daya (Jml)
      //"Volume (m3)",
      "Volume Progres(m³)", //Progres Saat ini (Diisi apabila sudah dimulai)
      "%", //Progres Saat ini (Diisi apabila sudah dimulai)
      "Status",
      "Keterangan",
    ];

    let filteredFields = fields?.filter((field) => field?.isHighlight === true);
    let field_badan_air_key = fields?.find(
      (field) => field?.name === "Jenis Badan Air"
    )?.key;

    if (layer?.layer_id === "68fba5cfc8804625c619be58") {
      const fieldMap = new Map(
        fields?.map((field) => [field.name, field]) || []
      );
      filteredFields = listFilteredFields
        .map((name) => fieldMap.get(name))
        .filter(Boolean);
    }

    const schemaByName = Object.fromEntries(
      schema?.map((s) => [String(s?.column).trim(), s])
    );

    // --- FIXED DATE LOGIC START ---
    const dateHappeningDataKey = fields?.find(
      (field) => field?.name === "Tanggal Kejadian"
    )?.key;

    let startDate = "-";
    let endDate = "-";

    if (dateHappeningDataKey) {
      try {
        // 1. Extract, 2. Convert to Date, 3. Filter Invalid Dates, 4. Sort
        const validDates = newData
          ?.map((row) => row[dateHappeningDataKey])
          .map((d) => new Date(d))
          .filter((dateObj) => !isNaN(dateObj.getTime())) // Filters out "Invalid Date"
          .sort((a, b) => a - b);

        if (validDates.length > 0) {
          const dateFormatter = new Intl.DateTimeFormat("id-ID", {
            year: "numeric",
            month: "long",
            day: "2-digit",
          });

          startDate = dateFormatter.format(validDates[0]);
          endDate = dateFormatter.format(validDates[validDates.length - 1]);
        }
      } catch (error) {
        console.error("Error calculating dates for PDF title:", error);
      }

      setData((prev) => ({
        ...prev,
        title: { ...prev.title, startDate: startDate, endDate: endDate },
      }));
    }
    // --- FIXED DATE LOGIC END ---

    const filteredSchema = filteredFields
      .map((item) => schemaByName[String(item.name).trim()])
      .filter(Boolean);
    
    const missing = filteredFields.filter(
      (field) => !schemaByName[String(field.name).trim()]
    );
    if (missing.length) {
      console.warn("Kolom tidak ditemukan di schema: ", missing);
      return;
    }

    const head = filteredSchema.map((s) => s.column);

    if (layer?.layer_id === "68fba5cfc8804625c619be58") {
      // Sorting berdasarkan jenis badan air pada laporan pengerukan
      // Fungsi pembantu: dapatkan indeks prioritas
      const getSortPriority = (value) => {
        const index = ["Waduk", "Kali/Sungai", "Saluran PHB"].indexOf(value);
        return index === -1 ? Infinity : index; //Nilai tidak dikenal ditempatkan di akhir
      };

      // Urutkan newData berdasarkan nilai di field_badan_air_key
      newData = [...newData].sort((a, b) => {
        if (!field_badan_air_key) return 0; //Jika key tidak ditemukan, jangan urutkan

        const valueA = a[field_badan_air_key] || "";
        const valueB = b[field_badan_air_key] || "";

        return getSortPriority(valueA) - getSortPriority(valueB);
      });
    }

    const body = newData.map((row) =>
      filteredSchema.map((col) => {
        const v = col.value(row);
        if (col.column === "Tanggal Kejadian") {
          // Note: This setData inside map loop is suspicious/inefficient in original code,
          // but keeping logic to avoid breaking legacy behavior if intended.
          // Ideally, title should be set once outside.
          setData((prev) => ({ ...prev, title: { ...prev.title } }));
        }
        return { value: v == null ? "" : String(v), type: col.type };
      })
    );

    setData((prev) => ({ ...prev, head: head, body: body }));
  }, [layer]);

  const tableTitle = useMemo(() => {
    const rekapitulasiPengerukanIds = allowedRekapitulasiPengerukanIds?.map(item => item?.id)

    if(layer?.layer_id === "68fba5cfc8804625c619be58"){
      return <span>"Rincian Pengerukan Lumpur di Provinsi DKI Jakarta"</span>
    } else if (rekapitulasiPengerukanIds?.includes(layer?.layer_id)){
      const sub_title = allowedRekapitulasiPengerukanIds?.find(item => item?.id === layer?.layer_id)?.sub_title
      return <span style={{fontSize: "16px", marginLeft: "7rem"}}>{sub_title}</span>
    } else {
      return <span>{`${data?.title?.layer} - Periode ${data?.title?.startDate} sampai ${data?.title?.endDate}`}</span>
    }
  },[layer, data, allowedRekapitulasiPengerukanIds])
  
  const tableFooter = useMemo(() => {
    const rekapitulasiPengerukanIds = allowedRekapitulasiPengerukanIds?.map(item => item?.id)
      // --- Footer Date Safety Helper ---
    const getFooterDate = () => {
      try {
        return new Date().toLocaleString("id-ID", {
          weekday: "long",
          year: "numeric",
          month: "long",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
          hour12: false,
          timeZone: "Asia/Jakarta",
        });
      } catch (e) {
        return "-";
      }
    };

    if(layer?.layer_id === "68fba5cfc8804625c619be58"){
      return <span>Rincian Pengerukan Lumpur di Provinsi DKI Jakarta</span>
    } else if(rekapitulasiPengerukanIds.includes(layer?.layer_id)){
      return <span>{`${data?.title?.layer}`} | Diunduh pada {getFooterDate()}</span>
    }
    else {
      return <span>{`${data?.title?.layer} - Periode ${data?.title?.startDate} sampai ${data?.title?.endDate} `}| Diunduh pada {getFooterDate()}</span>
    }
  },[allowedRekapitulasiPengerukanIds, data?.title?.endDate, data?.title?.layer, data?.title?.startDate, layer?.layer_id])

  const content = useMemo(() => {
    const rekapitulasiPengerukanIds = allowedRekapitulasiPengerukanIds?.map(item => item?.id)
    const table_title = allowedRekapitulasiPengerukanIds?.find(item => item?.id === layer?.layer_id)?.table_title || ""
    
    const allowedMediasFormats = [
      ".jpg",
      ".jpeg",
      ".png",
      ".webp",
      ".gif",
      ".bmp",
      ".svg",
      ".avif",
    ]

    const style = {
      textAlign: "center",
      verticalAlign: "middle",
      maxWidth: "100px",
      fontWeight: 700,
      border: "1px solid black",
      padding: "2px 5px",
    };
    
    if(layer?.layer_id === "68fba5cfc8804625c619be58"){
      const topHeaders = [
        "No.",
        "Lokasi",
        "Permasalahan yang Ingin Diselesaikan",
        "Sasaran",
        "Volume Target (m³)",
        "Waktu Pelaksanaan<br/>(yyyy-mm-dd)",
        "Rencana Kebutuhan Sumber Daya<br/>(Jml)",
        "Progres Saat Ini<br/>(Diisi apabila sudah dimulai)",
        "Status",
        "Keterangan",
      ];

      const bottomHeaders = [
        "Outcome",
        "Output",
        "Waktu Mulai",
        "Waktu Selesai",
        "Jumlah Alat Berat",
        "Jumlah Dump Truck",
        "Jumlah Satgas",
        "Volume Progres(m³)",
        "%",
      ];

      return (
        <>
          <thead>
            <tr>
              <th
                style={{
                  textAlign: "center",
                  verticalAlign: "middle",
                  border: "1px solid black",
                  fontWeight: 700,
                }}
                colSpan={17}
              >
                Pengerukan Lumpur Wilayah Jakarta
              </th>
            </tr>
            <tr>
              {topHeaders?.map((item, index) => (
                <th
                  colSpan={
                    [
                      "Sasaran",
                      "Waktu Pelaksanaan<br/>(yyyy-mm-dd)",
                      "Progres Saat Ini<br/>(Diisi apabila sudah dimulai)",
                    ].includes(item)
                      ? 2
                      : [
                          "Rencana Kebutuhan Sumber Daya<br/>(Jml)",
                        ].includes(item)
                      ? 3
                      : 1
                  }
                  rowSpan={
                    ![
                      "Sasaran",
                      "Waktu Pelaksanaan<br/>(yyyy-mm-dd)",
                      "Rencana Kebutuhan Sumber Daya<br/>(Jml)",
                      "Progres Saat Ini<br/>(Diisi apabila sudah dimulai)",
                    ].includes(item)
                      ? 2
                      : 1
                  }
                  key={index}
                  style={style}
                  dangerouslySetInnerHTML={{ __html: item }}
                />
              ))}
            </tr>
            <tr>
              {bottomHeaders?.map((item, index) => (
                <th key={index} style={style}>
                  {item}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {data?.body?.map((items, index) => (
              <tr key={index}>
                <td
                  key={index}
                  style={{ verticalAlign: "top", textAlign: "center" }}
                >
                  {Number(index) + 1}
                </td>
                {items?.map((item, index) =>
                  allowedMediasFormats?.some((ext) =>
                    item?.value?.toLowerCase().endsWith(ext)
                  ) ? (
                    <td
                      key={index}
                      style={{
                        textAlign: "center",
                        padding: "2px",
                      }}
                    >
                      <img
                        src={item.value}
                        style={{
                          maxWidth: "80px",
                          aspectRatio: "1/1",
                        }}
                        alt=""
                      />
                    </td>
                  ) : (
                    <td
                      key={index}
                      style={{
                        maxWidth: ["checklist"].includes(item.type)
                          ? "100px"
                          : "70px",
                        verticalAlign: "top",
                        textAlign: ["number", "date", "time"].includes(
                          item.type
                        )
                          ? "center"
                          : "left",
                      }}
                    >
                      {item?.type === "checklist"
                        ? (() => {
                            const value = item?.value.trim();
                            const values = value?.split("\n");
                            const tdStyle = {
                              verticalAlign: "top",
                              padding: 0,
                              margin: 0,
                            };

                            return values?.map((value, index) => (
                              <table
                                key={index}
                                style={{
                                  fontSize: allowedRekapitulasiPengerukanIds.map(item => item?.id).includes(layer?.layer_id) ? "12px" : ".45rem",
                                  padding: 0,
                                  margin: 0,
                                }}
                              >
                                <tbody
                                  style={{
                                    padding: 0,
                                    margin: 0,
                                  }}
                                >
                                  <tr>
                                    <td style={tdStyle}>-</td>
                                    <td style={tdStyle}>{value}</td>
                                  </tr>
                                </tbody>
                              </table>
                            ));
                          })()
                        : item?.value}
                    </td>
                  )
                )}
              </tr>
            ))}
          </tbody>
        </>
      );
    } else if (rekapitulasiPengerukanIds?.includes(layer?.layer_id)){ // Rekapitulasi Satpel, Sudin, Total
      const dateFormatter = new Intl.DateTimeFormat("id-ID", {
        year: "numeric",
        month: "long",
        day: "2-digit",
      });

      const currentDate = dateFormatter.format(new Date()) || ""

      const topHeaders = [
        "No", 
        "Suku Dinas",
        "JUMLAH LOKASI",
        "VOLUME"
      ]
      const bottomHeaders = [
        "Jumlah Lokasi Pengerukan",
        "Jumlah Lokasi Selesai (100%)",
        "Jumlah Lokasi Dalam Proses Pengerukan",
        "Jumlah Lokasi Belum Dimulai",
        "Target Volume ",
        "Volume Progres Pengerukan 2026 (m3)",
        "Persetase Volume (%)"
      ]

      const headerStyle = {
        textAlign: "center",
        verticalAlign: "middle",
        fontWeight: 700,
      }

      return (
        <>
          <thead>
            <tr>
              <th 
                style={{...headerStyle, fontSize: "12px"}}
                colSpan={9}
              >
                {table_title}
              </th>
            </tr>
            <tr>
              <th
                style={{...headerStyle, border: "1px solid black"}}
                colSpan={9}
              >
                PENGERUKAN DAN PEMELIHARAAN RUTIN PER-{currentDate} (Single Year)
              </th>
            </tr>
            <tr>
              {topHeaders?.map((item, index) => (
                <th
                  colSpan={
                    [
                      "JUMLAH LOKASI",
                      "VOLUME"
                    ].includes(item)
                    ? 4
                    : ["VOLUME"].includes(item)
                    ? 3
                    : 1
                  }
                  rowSpan={
                    ["No","Suku Dinas"].includes(item)
                    ? 2
                    : 1
                  }
                  key={index}
                  style={style}
                  dangerouslySetInnerHTML={{__html: item}}
                />
              ))}
            </tr>
            <tr>
              {bottomHeaders?.map((item, index) => (
                <th key={index} style={style}>
                  {item}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {data?.body?.map((items, index) => (
              <tr 
                key={index}
                style={{ verticalAlign: "top", textAlign: "center" }}
              >
                <td>
                  {Number(index) + 1}
                </td>
                {items?.map((item, index) => (
                  <td
                    key={index}
                    style={{
                      maxWidth: ["checklist"].includes(item?.type)
                        ? "100px"
                        : "70px",
                      verticalAlign: "top",
                      textAlign: ["number", "date", "time"].includes(
                        item?.type
                      )
                        ? "center"
                        : "left",
                    }}
                  >
                    {item?.value}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </>
      )
    } else {
      return (
        <>
          <thead>
            <tr>
              <th
                style={{
                  textAlign: "center",
                  verticalAlign: "middle",
                  border: "1px solid black",
                  fontWeight: 700,
                }}
              >
                No.
              </th>
              {data?.head?.map((item, index) => (
                <th
                  key={index}
                  style={{
                    textAlign: "center",
                    verticalAlign: "middle",
                    maxWidth: "50px",
                    fontWeight: 700,
                    border: "1px solid black",
                    padding: "2px",
                  }}
                >
                  {item}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {data?.body?.map((items, index) => (
              <tr key={index}>
                <td
                  key={index}
                  style={{ verticalAlign: "top", textAlign: "center" }}
                >
                  {Number(index) + 1}
                </td>
                {items?.map((item, index) =>
                  allowedMediasFormats?.some((ext) =>
                    item?.value.toLowerCase().endsWith(ext)
                  ) ? (
                    <td
                      key={index}
                      style={{
                        textAlign: "center",
                        padding: "2px",
                      }}
                    >
                      <img
                        src={item?.value}
                        style={{
                          maxWidth: "80px",
                          aspectRatio: "1/1",
                        }}
                        alt=""
                      />
                    </td>
                  ) : (
                    <td
                      key={index}
                      style={{
                        maxWidth: ["checklist"].includes(item?.type)
                          ? "100px"
                          : "70px",
                        verticalAlign: "top",
                        textAlign: ["number", "date", "time"].includes(
                          item?.type
                        )
                          ? "center"
                          : "left",
                      }}
                    >
                      {item?.type === "checklist"
                        ? (() => {
                            const value = item?.value.trim();
                            const values = value?.split("\n");
                            const tdStyle = {
                              verticalAlign: "top",
                              padding: 0,
                              margin: 0,
                            };

                            return values.map((value, index) => (
                              <table
                                key={index}
                                style={{
                                  fontSize: ".45rem",
                                  padding: 0,
                                  margin: 0,
                                }}
                              >
                                <tbody
                                  style={{
                                    padding: 0,
                                    margin: 0,
                                  }}
                                >
                                  <tr>
                                    <td style={tdStyle}>-</td>
                                    <td style={tdStyle}>{value}</td>
                                  </tr>
                                </tbody>
                              </table>
                            ));
                          })()
                        : item?.value}
                    </td>
                  )
                )}
              </tr>
            ))}
          </tbody>
        </>
      )
    }
  },[layer, data, allowedRekapitulasiPengerukanIds])

  return (
    <>
      <button
        onClick={onClick}
        title="UNDUH PDF"
        className="button_download_data"
      >
        {loading ? (
          <CircularProgress size={20} thickness={8} sx={{ color: "black" }} />
        ) : (
          <img src={logo_pdf} width={40} alt="icon download pdf" />
        )}
        <p className="layer_action_label inactive_label">PDF</p>
      </button>

      <div style={{ display: "none" }}>
        <div
          ref={contentRef}
          style={{
            width: "auto",
            display: "flex",
            flexDirection: "column",
            alignItems: allowedRekapitulasiPengerukanIds?.map(item => item?.id)?.includes(layer?.layer_id) ? "stretch" : "left",
            paddingTop: "4mm",
            paddingBottom: "4mm",
            gap: 5,
            fontSize: allowedRekapitulasiPengerukanIds.map(item => item?.id).includes(layer?.layer_id) ? "14px" : "12px"
          }}
        >
          <div style={{textAlign: "left"}}>
            {tableTitle}
          </div>
          <div style={{
            display: "flex", 
            justifyContent: allowedRekapitulasiPengerukanIds.map(item => item?.id).includes(layer?.layer_id) ? "center" : "left",
          }}>
            <table
              border="1"
              style={{
                tableLayout: "auto",
                borderCollapse: "collapse",
                fontSize: ".55rem",
                width: "max-content",
              }}
            >
              {content}
            </table>
          </div>

          {/* --- TAMBAHKAN FOOTER DENGAN NOMOR HALAMAN DI SINI --- */}
          <div
            style={{
              position: "fixed",
              bottom: "0",
              left: "0",
              fontSize: "8pt",
              color: "gray",
              textAlign: "center",
              zIndex: 1000,
            }}
          >
            {tableFooter}
          </div>
          {/* --- AKHIR FOOTER --- */}
        </div>
      </div>
    </>
  );
}
